import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { PresentationIcon24Regular } from "../../../../../icons2022/FileTypePresentationIcon/PresentationIcon24Regular";
import { PresentationIcon32Regular } from "../../../../../icons2022/FileTypePresentationIcon/PresentationIcon32Regular";
import { PresentationIcon64Regular } from "../../../../../icons2022/FileTypePresentationIcon/PresentationIcon64Regular";
export var PresentationIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(PresentationIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(PresentationIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(PresentationIcon64Regular, null);
  }
}, 'PresentationIcon');